import { Component } from '@angular/core';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

/**
 * The "Register and Update Your User Profile" how-to page: a set of
 * collapsible sections walking through first-time registration, USDA email
 * verification, keeping a profile up to date, and what happens next.
 */
@Component({
  selector: 'ciao-register-user-profile',
  templateUrl: './register-user-profile.component.html',
  styleUrls: ['./register-user-profile.component.less'],
  standalone: false,
})
export class RegisterUserProfileComponent {
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;

  /** Where the page's screenshots live. */
  readonly img = '/assets/help/img/register-profile';

  // Collapsed by default: the page is long, and the section titles work as a
  // table of contents until the reader picks one.
  open = {
    registering: false,
    verification: false,
    updating: false,
    addedToTeam: false,
    adminOrSupervisor: false,
  };

  toggle(key: keyof typeof this.open) {
    this.open[key] = !this.open[key];
  }

  get allOpen(): boolean {
    return Object.values(this.open).every(Boolean);
  }

  /** One control that collapses everything, or expands everything back. */
  toggleAll() {
    const next = !this.allOpen;
    (Object.keys(this.open) as (keyof typeof this.open)[]).forEach(
      (key) => (this.open[key] = next)
    );
  }
}
